<template>    
    <div class="home">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Resumen
          <v-btn icon @click="deleteDocument">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-layout wrap align-center>            
            <v-flex xs10 offset-xs1 mb-3>
              <TimeTable/>
            </v-flex>      
            <!--v-flex xs10 offset-xs1 mb-3>
              <v-file-input
                multiple
                dense
                prepend-icon="mdi-camera"
                v-model="images"
                @change="test"
              ></v-file-input>
            </v-flex-->
            <v-flex xs10 offset-xs1 mb-3>
                <v-checkbox
                    v-if="this.$store.state.relation == ''"
                    v-model="custSignature"
                    label="Incluir firma de cliente"
                ></v-checkbox>
                <v-tabs :show-arrows="false" v-model="tab" grow dense>
                    <v-tab v-if="(this.$store.state.relation == '') && custSignature">Cliente</v-tab>
                    <v-tab>Fotos</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">     
                    <v-layout v-if="custSignature" wrap>
                        <v-flex xs12 md6 xl3><span class="bold">Fecha: </span>{{ new Date(this.$store.state.fechaParte).toLocaleDateString("es-ES")}}</v-flex>
                        <v-flex xs12 md6 xl3><span class="bold">Vehículo: </span>{{this.resourcesInLines}}</v-flex>
                        <v-flex xs12 md6 xl3><span class="bold">Origen: </span>{{this.$store.state.parteDetalleObject.Lines[0].origen}} 
                        <span class="bold">Destino: </span>{{this.$store.state.parteDetalleObject.Lines[0].destino}}</v-flex>
                        <v-flex xs12 md6 xl3><span class="bold">Horario: </span>{{this.hoursInLines}}</v-flex>
                        <v-flex xs12 md6 xl3><span class="bold">Operarios: </span>{{this.operarios}}</v-flex>
                        <v-flex xs12 md6 xl3 v-if="taskDescriptions != ''"><span class="bold">Desc. Tarea: </span>{{taskDescriptions}}</v-flex>
                    </v-layout>               
                    <v-tab-item v-if="(this.$store.state.relation == '') && custSignature">
                        <SignaturePad :type="'cust'"/>        
                    </v-tab-item>
                    <v-tab-item>
                        <Uploader/>
                    </v-tab-item>
                </v-tabs-items>
            </v-flex>
            <!--v-flex xs8 offset-xs2 mb-5>
              <v-btn block color="warning" dark @click="openCustomerSignatureDialog">Firma Cliente</v-btn>
            </v-flex-->
        </v-layout> 
        <br>    
        <br>        
        <v-divider></v-divider>       
        <v-footer absolute padless>
          <v-flex xs4 offset-xs1>
            <v-btn block color="warning" :loading="isLoading"  dark @click="back">Volver</v-btn>
          </v-flex> 
          <v-flex xs4 offset-xs2>
            <v-btn block color="success" :loading="isLoading"  dark @click="updateDocument">Finalizar</v-btn>
          </v-flex> 
        </v-footer>
    </div> 
</template>
<script>

import TimeTable from '@/components/TimeTable.vue'
import SignaturePad from '@/components/SignaturePad.vue'
import Uploader from '@/components/ImageUploader.vue'
import store from '../store';

export default {
    name: 'ResumenEdit',
    components:{
      TimeTable,
      SignaturePad,
      Uploader
    },
    data () {
      return {  
        tab : 0,
        custSignature: true
      }
    },
    methods:{
        back(){
            this.$router.go(-1);
        },
        close(){
            this.dialog = false;                        
        },
        closeOK(){            
            this.dialog = false;                        
        },                
        openCustomerSignatureDialog(){
          store.state.dialogSignatureCustomer = true;
        },
        deleteDocument(){
          store.commit('resetDataAfterSuccessfulCreation');
        }
    },
    mounted(){
      this.getWorkTypes();
    },
    watch:{      
    },
    computed:{
        taskDescriptions: {
            get(){
                var lines = this.$store.state.lineasParte.filter(lin => (lin.taskDescription != ''));
                var res = '';
                lines.forEach(lin => {
                    if (res != '') res += ' - ';
                    res += lin.taskDescription
                });
                return res;
            }
        },
        dialog: {
            get(){
                return this.$store.state.dialogSummary;
            },
            set(value){
                this.$store.state.dialogSummary = value;
            }
        },
        proyectos:{
            get(){
                return this.$store.state.jobs;
            }
        },
        tareas:{
            get(){
                return this.$store.state.jobTasks;
            }
        },
        proyecto:{
            get(){
                return this.$store.state.proyecto;                
            }/*,
            set(value){
                this.$store.state.proyecto = value;
            }*/
        },
        proyectoFullName:{
            get(){
                var jobno = this.$store.state.proyecto;
                var fullname = '';
                if (jobno != ''){
                  var res = this.$store.state.proyectos.find(job =>{
                    return job.no == jobno;
                  });
                  console.log(res);
                }
                return fullname;
            }
        },
        tarea:{
            get(){
                return this.$store.state.tarea;
            }/*,
            set(value){
                this.$store.state.tarea = value;
            }*/
        },
        images:{
            get(){
                return this.$store.state.images;
            },
            set(value){
                this.$store.state.images = value;
            }
        },
        isLoading:{
            get(){
                return this.$store.state.isLoading;
            }
        },
        resourcesInLines:{
            get(){
                var res = "";
                this.$store.state.parteDetalleObject.Lines.forEach(line => {
                    if (line.startTimeInvoiceable != undefined){
                        if (res != '') res += ', ';
                        if (line.resource != '') res += line.resource;
                    }
                });
                return res;
            }
        },
        hoursInLines:{
            get(){
                var start = 2400;
                var startStr = '';
                var end = 0;
                var endStr = '';
                var timeToInt = '';
                this.$store.state.parteDetalleObject.Lines.forEach(line => {
                    if ((line.invoiceableTimeCount != 0) /*&& (line.workType != '')*/){
                        /*var lineWorktype = store.state.workTypes.find(wt => (wt.code == line.workType));
                        if (!lineWorktype.extra){*/
                            if ((line.startTimeInvoiceable != undefined) && (line.invoiceableTimeCountUom != '')){
                                timeToInt = line.startTimeInvoiceable.substring(11,16);
                                var b = timeToInt;
                                timeToInt = timeToInt.replace(':','');
                                console.log(timeToInt);
                                if (Number(timeToInt) < start) {
                                    start = timeToInt;
                                    startStr = b;
                                }
                            }
                            if ((line.endTimeInvoiceable != undefined) && (line.invoiceableTimeCountUom != '')){
                                timeToInt = line.endTimeInvoiceable.substring(11,16);
                                var b_ = timeToInt;
                                timeToInt = timeToInt.replace(':','');
                                if (Number(timeToInt) > end){
                                    end = timeToInt;
                                    endStr = b_;
                                }
                            }
                        //}
                    }
                });
                return startStr + " - " + endStr;
            }
        },
        operarios:{
            get(){
                var res = "";
                this.$store.state.user.forEach(usr => {
                    console.log(usr)
                    var userData = this.$store.state.users.find(u =>{
                        return u.User == usr;
                    })
                    console.log(userData);
                    if (res != '') res += ', ';
                    if (userData)
                        res += userData.Name;
                });
                return this.$store.state.usuario.name + ', ' + res;
            }
        }
    }
}
</script>
<style>
.bold{
    font-weight: bold;
}
</style>
